module.exports = __webpack_public_path__ + "static/media/ExL-Logo-Rebranddark-2.06080134.png";